@if (table.length > 0) {
  <p-treeTable
    #tt
    sortField="name"
    filterMode="lenient"
    [value]="table"
    [columns]="cols"
    [scrollable]="true"
    [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center">
        @if (activeUserStore.isAdmin()) {
          <p-button
            [rounded]="true"
            icon="fas fa-check-double"
            label="Validierung"
            severity="help"
            (onClick)="validateIndicators()"
            [outlined]="true"></p-button>
        }
        <div class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            class="border-round-3xl"
            pInputText
            #searchInput
            type="text"
            (input)="tt.filterGlobal(searchInput.value, 'contains')"
            placeholder="durchsuchen ..." />
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowNode
      let-rowData="rowData"
      let-columns="columns">
      <tr [ttRow]="rowNode">
        <td *ngFor="let col of columns; let i = index">
          <div class="flex align-items-center">
            @switch (i) {
              @case (0) {
                <p-treeTableToggler [rowNode]="rowNode" />
                <span>{{ rowData[col.field] }} </span>
              }
              @case (3) {
                @if (i === 3 && rowData.dataInternal) {
                  <div class="flex gap-2">
                    <p-tag
                      [value]="rowData.dataInternal || '0'"
                      icon="fas fa-house-user"
                      severity="secondary"
                      [rounded]="true"></p-tag>
                    <p-tag
                      [value]="rowData.dataExternal || '0'"
                      icon="fas fa-globe-europe"
                      severity="info"
                      [rounded]="true"></p-tag>
                  </div>
                } @else if (rowData.data) {
                  <p-tag
                    [rounded]="true"
                    [value]="rowData[col.field]"
                    [icon]="
                      rowData[col.field] === 'Intern'
                        ? 'fas fa-house-user'
                        : 'fas fa-globe-europe'
                    "
                    [severity]="
                      rowData[col.field] === 'Intern' ? 'secondary' : 'info'
                    "></p-tag>
                } @else if (!rowData.data) {
                  <i class="text-color-secondary font-italic"
                    >keine Daten hinterlegt</i
                  >
                }
              }
              @default {
                <span>{{ rowData[col.field] }}</span>
              }
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
}

<p-sidebar
  [(visible)]="validationSidebarVisible"
  position="right"
  [style]="{ width: '80vw' }"
  [closeOnEscape]="true">
  <ng-template pTemplate="header">
    <app-header
      icon="fas fa-check-double"
      text="Indikator-Validierung"
      sub="Die Liste zeigt alle Indikatoren an, die mehrfach in ihrem Baum vorhanden sind. Diese können gelöscht werden, um die Datenkonsistenz zu gewährleisten. Dabei werden Indikatoren ignoriert, die bereits Daten beinhalten."></app-header>
  </ng-template>

  @if (validationResult) {
    <app-indicator-validation-list
      (deleted)="validateIndicators()"
      [duplicateIndicators]="
        validationResult.indicatorsWithoutData
      "></app-indicator-validation-list>
  }
</p-sidebar>
<app-mask
  (click)="validationSidebarVisible = false"
  [visible]="validationSidebarVisible"></app-mask>
